import { useTranslation } from 'react-i18next'
import { Button } from './ui/button'
import { useQuiz } from '@renderer/lib/useQuiz'
import { AnimatePresence, motion } from 'motion/react'
import { useEffect, useState } from 'react'
import logo from './logo.svg'

const TopBar = () => {
  const { i18n, t } = useTranslation()
  const { currentQuiz, currentIndex, totalQuestions, reset } = useQuiz()
  const [showModal, setShowModal] = useState(false)

  // const changeLanguage = (lng: string) => {
  //   i18n.changeLanguage(lng)
  // }

  useEffect(() => {
    console.log(i18n.language)
  }, [i18n.language])

  const handleLogoClick = () => {
    if (currentQuiz) {
      setShowModal(true)
    }
  }

  const handleQuit = () => {
    reset()
    setShowModal(false)
  }

  const getDynamicText = () => {
    if (currentQuiz) {
      return t(`${currentQuiz}.title`).replace(/\n/g, ' – ')
      return t('quiz.question_number', { 
        question: currentIndex + 1, 
        total: totalQuestions 
      })
    }
    return t('home.title')
  }

  return (
    <>
      <div className="shrink-0 w-full bg-grey-200 shadow-md px-4 flex items-center justify-between h-[10vh] [@media(max-height:1100px)]:h-[8vh] [@media(min-height:1101px)]:h-[12vh] [@media(min-height:1101px)]:px-6">
        {/* Logo à gauche */}
        <div className="flex items-center bg-white border-4 border-primary">
          <img 
            src={logo}
            alt="RATP Logo" 
            className="cursor-pointer hover:opacity-80 transition-opacity h-12 [@media(max-height:1100px)]:h-10 [@media(min-height:1101px)]:h-16"
            onClick={handleLogoClick}
          />
        </div>

        {/* Texte dynamique au centre */}
        <div className="flex-1 text-center px-2">
          <h1 className="font-bold text-primary leading-tight text-xl [@media(max-height:1100px)]:text-base [@media(min-height:1101px)]:text-2xl [@media(min-height:1101px)]:lg:text-xxl">
            {getDynamicText()}
          </h1>
        </div>

        {/* Sélecteur de langue à droite */}
        {/* <div className="flex items-center gap-2">
          <Button 
            variant="outline"
            onClick={() => changeLanguage('fr')}
            className={`text-sm border-primary text-primary hover:bg-primary/10 ${
              i18n.language === 'fr' ? 'bg-primary text-white hover:bg-primary/90' : 'bg-white'
            }`}
          >
            FR
          </Button>
          <Button 
            variant="outline"
            onClick={() => changeLanguage('en')}
            className={`text-sm border-primary text-primary hover:bg-primary/10 ${
              i18n.language === 'en' ? 'bg-primary text-white hover:bg-primary/90' : 'bg-white'
            }`}
          >
            EN
          </Button>
        </div> */}
      </div>

      {/* Modal de confirmation */}
      <AnimatePresence>
        {showModal && (
          <>
            {/* Overlay */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/50 z-50"
              onClick={() => setShowModal(false)}
            />
            
            {/* Modal */}
            <motion.div
              initial={{ y: -100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -100, opacity: 0 }}
              transition={{ type: 'spring', bounce: 0.2, duration: 0.3 }}
              className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-6 shadow-lg z-50"
            >
              <h2 className="text-xl font-bold mb-4 text-primary">{t('quiz.quit_confirmation.title', 'Êtes-vous sûr de vouloir quitter le quiz ?')}</h2>
              <p className="mb-6 text-primary">{t('quiz.quit_confirmation.message', 'Tous vos progrès seront perdus.')}</p>
              <div className="flex justify-end gap-4">
                <Button
                  variant="outline"
                  onClick={() => setShowModal(false)}
                  className="border-primary text-primary hover:bg-primary/10"
                >
                  {t('quiz.quit_confirmation.cancel', 'Annuler')}
                </Button>
                <Button
                  onClick={handleQuit}
                  className="bg-primary text-white hover:bg-primary/90"
                >
                  {t('quiz.quit_confirmation.confirm', 'Quitter 2')}
                </Button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  )
}

export default TopBar